// prettier-ignore
export default {
    "admin_barcode": "/gestione/codici-a-barre/",
    "upload_s3": "/api/storage/uploader/s3/",
    "imposition_prepress": "/impaginato/prepress/json/",
    "imposition_prepress_blank": "/impaginato/prepress_blank/json/",
    "upload_outfolders": "/api/storage/switch-outfolders/",
    "autocomplete": "/autocomplete/${name}/?v=2025.1107.0942",
    "notify_frontend_error": "/api/frontend-errors/"
} as const